// 多语言切换配置
export default [
    {label: '简体中文', value: 'zhCN'},
    {label: 'English', value: 'en'},
]
